import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

const CountrySelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const countryData = useSelector((state) => state.config.countryData);
    const selectedCountry = useSelector((state) => state.playersAndTeams.filter.values.nationalityCode);
    const selectedStateOrProvince = useSelector((state) => state.playersAndTeams.filter.values.birthStateProvinceCode);

    const setPlayerNationality = (e, { value }) => {
        dispatch(filterActionCreators.setPlayerNationality(value));
    };

    const countryOptions = countryData.map((country) => ({
        value: country.id,
        label: country.countryName,
        key: country.id,
    }));

    const options = [
        {
            value: '',
            label: intl.formatMessage(commonMessages.advancedFilters['nationalityCode.all']),
        },
        ...countryOptions,
    ];
    const value = options.find((obj) => obj.value === selectedCountry);
    const isDisabled = selectedStateOrProvince !== '';

    return (
        <Select
            onOptionChange={setPlayerNationality}
            options={options}
            selectedOption={value}
            isSelectDisabled={isDisabled}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(CountrySelect);
